import { IReferenceArticle, IReferenceCategory } from '@modules/reference/types/models';
import { IReferenceState } from '@modules/reference/types/store';

export const categories: IReferenceCategory[] = [
  {
    id: 1,
    name: 'Аккаунт',
    subCategories: [
      { id: 10, name: 'Блок 1' },
      { id: 11, name: 'Блок 2' },
      { id: 12, name: 'Блок 3' }
    ]
  },
  {
    id: 2,
    name: 'Данные',
    subCategories: [
      { id: 13, name: 'Загрузка данных через файл. Просмотр.' },
      { id: 14, name: 'Описание API.' },
      { id: 15, name: 'Валидация' }
    ]
  },
  {
    id: 3,
    name: 'Планирование',
    subCategories: [
      { id: 16, name: 'Расчет' },
      { id: 17, name: 'Параметры (конфигурации)' }
    ]
  },
  {
    id: 4,
    name: 'Справочники',
    subCategories: [
      { id: 101, name: 'Заявки' },
      { id: 102, name: 'Клиенты' },
      { id: 103, name: 'Парк машин' }
    ]
  },
  {
    id: 5,
    name: 'Мониторинг',
    desc: 'desc',
    subCategories: [
      { id: 19, name: 'Дашборд' },
      { id: 20, name: 'Рейсы на карте' },
      { id: 21, name: 'Контроль поставок' }
    ]
  },
  {
    id: 6,
    name: 'Аналитика (отчеты)',
    desc: 'desc',
    subCategories: [
      { id: 22, name: 'Доски' },
      { id: 23, name: 'Отчеты' },
      { id: 24, name: 'Рейсы' },
      { id: 25, name: 'Посещения' },
      { id: 26, name: 'Качество' }
    ]
  },
  { id: 7, name: 'Настройки' },
  { id: 8, name: 'Условные обозначения' }
];

export const article: IReferenceArticle = {
  time: 1624015218034,
  blocks: [
    {
      id: 'IMfGlMSbtW',
      type: 'header',
      data: {
        text: 'Editor.js',
        level: 2
      }
    },
    {
      id: 'X6IMXAbryN',
      type: 'paragraph',
      data: {
        text: 'Hey. Meet the new Editor. On this page you can see it in action — try to edit this text.'
      }
    },
    {
      id: 'RsTK0zJoYO',
      type: 'header',
      data: {
        text: 'Key features',
        level: 3
      }
    },
    {
      id: 'H-hzLReypL',
      type: 'list',
      data: {
        style: 'unordered',
        items: [
          'It is a block-styled editor',
          'It returns clean data output in JSON',
          'Designed to be extendable and pluggable with a simple API'
        ]
      }
    },
    {
      id: 'YKxanYVST4',
      type: 'header',
      data: {
        text: 'What does it mean «block-styled editor»',
        level: 3
      }
    },
    {
      id: 'tTZRahuh_t',
      type: 'paragraph',
      data: {
        text: 'Workspace in classic editors is made of a single contenteditable element, used to create different HTML markups. Editor.js <mark class="cdx-marker">workspace consists of separate Blocks: paragraphs, headings, images, lists, quotes, etc</mark>. Each of them is an independent contenteditable element (or more complex structure) provided by Plugin and united by Editor\'s Core.'
      }
    },
    {
      id: 'CB17JITuTg',
      type: 'paragraph',
      data: {
        text: 'There are dozens of <a href="https://github.com/editor-js">ready-to-use Blocks</a> and the <a href="https://editorjs.io/creating-a-block-tool">simple API</a> for creation any Block you need. For example, you can implement Blocks for Tweets, Instagram posts, surveys and polls, CTA-buttons and even games.'
      }
    },
    {
      id: 'sY9YgJaNwA',
      type: 'header',
      data: {
        text: 'What does it mean clean data output',
        level: 3
      }
    },
    {
      id: 'x-AjN-WL_1',
      type: 'paragraph',
      data: {
        text: 'Classic WYSIWYG-editors produce raw HTML-markup with both content data and content appearance. On the contrary, Editor.js outputs JSON object with data of each Block. You can see an example below'
      }
    },
    {
      id: '3WfVBiBWqo',
      type: 'paragraph',
      data: {
        text: 'Given data can be used as you want: render with HTML for <code class="inline-code">Web clients</code>, render natively for <code class="inline-code">mobile apps</code>, create markup for <code class="inline-code">Facebook Instant Articles</code> or <code class="inline-code">Google AMP</code>, generate an <code class="inline-code">audio version</code> and so on.'
      }
    },
    {
      id: 'wbc3dcWxjl',
      type: 'paragraph',
      data: {
        text: 'Clean data is useful to sanitize, validate and process on the backend.'
      }
    },
    {
      id: '7klkAj3y_x',
      type: 'delimiter',
      data: {}
    },
    {
      id: 'GNdxUvQjsj',
      type: 'paragraph',
      data: {
        text: "We have been working on this project more than three years. Several large media projects help us to test and debug the Editor, to make it's core more stable. At the same time we significantly improved the API. Now, it can be used to create any plugin for any task. Hope you enjoy. 😏"
      }
    },
    {
      id: 'XR_yRtUjru',
      type: 'image',
      data: {
        file: {
          url: 'https://codex.so/public/app/img/external/codex2x.png'
        },
        caption: '',
        withBorder: false,
        stretched: false,
        withBackground: false
      }
    }
  ],
  version: '2.22.0'
};

const initialState: IReferenceState = {
  isFetching: false,
  level1: {
    categories: categories,
    article: null
  },
  level2: {
    categories: [],
    article: null
  },
  level3: {
    categories: [],
    article: null
  }
};

export default initialState;
